module.exports = __webpack_public_path__ + "static/media/connect_disconnected.0b15611f.svg";